import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from './Modal';
import { BottomSheet } from './BottomSheet';

export interface ResponsiveOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  variant?: 'modal' | 'dropdown';
  className?: string; // Container content class
  isPortal?: boolean; // Whether to use portal on desktop
  style?: React.CSSProperties; // Optional inline styles for the container
}

export function ResponsiveOverlay({
  isOpen,
  onClose,
  children,
  variant = 'modal',
  className = '',
  isPortal = true,
  style = {},
}: ResponsiveOverlayProps) {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 640 : false);

  useEffect(() => {
    let resizeTimer: NodeJS.Timeout;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setIsMobile(window.innerWidth < 640);
      }, 50);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const desktopContent = (
    <Modal
      isOpen={isOpen && !isMobile}
      onClose={onClose}
      variant={variant}
      className={className}
      style={style}
    >
      {children}
    </Modal>
  );

  const mobileContent = (
    <BottomSheet
      isOpen={isOpen && isMobile}
      onClose={onClose}
      className={className}
    >
      {children}
    </BottomSheet>
  );

  const renderContent = () => (
    <>
      {isMobile ? mobileContent : desktopContent}
    </>
  );

  return (isPortal || isMobile) && typeof document !== 'undefined' 
    ? createPortal(renderContent(), document.body) 
    : renderContent();
}
